export default {
  PLACEHOLDER_SELECT_ADDRESS: 'Séléctionnez une adresse',
  INVOICES_MY_INVOICES: 'Mes factures',
  INVOICES_INVOICES_PURCHASE_HISTORY: 'Factures / Historique des commandes',
  INVOICES_NO_INVOICES_FOUND: 'Aucune facture n’est disponible pour le moment.',
  INVOICES_ORDER_NUMBER: 'Numéro de commande',
  INVOICES_INVOICE_DATE: 'Date de facturation',
  INVOICES_PAYMENT_METHOD: 'Mode de paiement',
  INVOICES_PRICES: 'Prix',
  INVOICES_DOWNLOAD: 'Téléchargement',
  INVOICES_PER_PAGE: '/ page',
  PAYMENT_METHOD_CREDIT_CARD: 'Carte de crédit',
  PAYMENT_METHOD_ADVANCED_PAYMENT: 'Virement bancaire',
  CHECKOUT_DELIVER_TO: 'Livraison à :',
  CHECKOUT_BILLING_TO: 'Facturation à :',
  CHECKOUT_SAMPLE_COPIES_ADDRESS: 'Adresse de livraison des échantillons',
  CARD_ITEM_BUTTON_SAMPLE_COPIES: 'Échantillons',
  CUSTOMER_SERVICE_TITLE: 'Service client',
  CUSTOMER_SERVICE_CONTACT: 'Contact',
  CUSTOMER_SERVICE_AVAILABLE_FROM: 'Disponible à partir de',
  CUSTOMER_SERVICE_AVAILABLE_UNTIL: "Disponible jusqu'à",
  CHANGE_PW_TITLE: 'Votre mot de passe doit être modifié.',
  CHANGE_PW_CHANGE: 'Mettre à jour les identifiants',
  CHANGE_PW_CURRENT_PW: 'Mot de passe actuel*',
  CHANGE_PW_NEW_PW: 'Nouveau mot de passe*',
  CHANGE_PW_REPEAT_PW: 'Répétez le nouveau mot de passe*',
  CHANGE_PW_EMAIL_MISMATCH: "L'adresse e-mail ne correspond pas à celle de l'utilisateur actuellement connecté.",

  ASSERT_FIELD_REQUIRED: 'Ce champ est requis',
  ASSERT_MINIMUM_LENGTH: 'Nombre minimum de caractères :',
  ASSERT_MAXIMUM_LENGTH: 'Nombre maximum de caractères :',
  ASSERT_BOTH_FIELDS_MUST_BE_EQUAL: 'Les deux champs doivent être identiques.',
  ASSERT_INVALID_EMAIL: 'Saisissez une adresse e-mail valide.',
  ASSERT_INVALID_PASSWORD:
    'Votre mot de passe doit contenir au moins 8 caractères, dont une majuscule, une minuscule, un chiffre et un caractère spécial.',

  AWS_COGNITO_ERROR_ATTEMPT_LIMIT: 'Trop de tentatives. Réessayez plus tard.',
  AWS_COGNITO_ERROR_USER_NOT_CONFIRMED:
    "Votre compte n'a pas encore été confirmé. Cliquez sur le lien dans l'e-mail de confirmation que nous vous avons envoyé.",
  AWS_COGNITO_ERROR_PASSWORD_RESET_REQUIRED: 'Vous devez réinitialiser votre mot de passe avant de vous connecter.',
  AWS_COGNITO_ERROR_NETWORK:
    "Impossible de se connecter au service d'authentification. Réessayez dans quelques instants.",
  AWS_COGNITO_ERROR_TOO_MANY_REQUESTS:
    'Notre service reçoit actuellement un grand nombre de demandes. Réessayez dans quelques instants.',
  AWS_COGNITO_ERROR_LIMIT_EXCEEDED:
    'Trop de demandes ont été effectuées pour ce compte. Attendez quelques minutes avant de réessayer.',
  AWS_COGNITO_ERROR_SESSION_EXPIRED: 'Votre session a expiré. Reconnectez-vous avec votre mot de passe temporaire.',

  LOGIN_EMAIL: 'Adresse e-mail*',
  LOGIN_PASSWORD: 'Mot de passe*',
  LOGIN_LOGIN: "S'identifier",
  LOGIN_FORGOT_PASSWORD: 'Réinitialiser votre mot de passe',

  FORGOT_PASSWORD_CODE_SENT:
    'Si cette adresse e-mail est associée à un compte, vous recevrez prochainement un code de réinitialisation de votre mot de passe.',
  FORGOT_PASSWORD_INVALID_CODE: 'Invalid verification code provided, please try again.',
  FORGOT_PASSWORD_SEND_CODE: 'Envoyer le code de réinitialisation',
  FORGOT_PASSWORD_EMAIL: 'Adresse e-mail*',
  FORGOT_PASSWORD_RESET_CODE: 'Code de réinitialisation*',
  FORGOT_PASSWORD_NEW_PASSWORD: 'Nouveau mot de passe*',
  FORGOT_PASSWORD_REPEAT_NEW_PASSWORD: 'Répéter le nouveau mot de passe*',
  FORGOT_PASSWORD_BACK_TO_LOGIN: 'Se reconnecter',
  FORGOT_PASSWORD_RESET_PASSWORD: 'Réinitialiser le mot de passe',
  FORGOT_PASSWORD_CODE_RESENT:
    'Si cette adresse e-mail est associée à un compte, vous recevrez prochainement un code de réinitialisation de votre mot de passe.',
  FORGOT_PASSWORD_HINTS_TITLE: "Vous n'avez pas reçu l'e-mail ?",
  FORGOT_PASSWORD_HINT_SPAM: 'Vérifiez votre dossier de courriers indésirables (spams).',
  FORGOT_PASSWORD_HINT_EMAIL: "Assurez-vous d'avoir saisi la bonne adresse e-mail",
  FORGOT_PASSWORD_CHANGE_EMAIL: "Modifier l'adresse e-mail",
  FORGOT_PASSWORD_HINT_RESEND: 'Renvoyer le code de réinitialisation',
  LOGIN_RESEND_CONFIRMATION: "Renvoyer l'e-mail de confirmation",
  LOGIN_RESEND_CONFIRMATION_SUCCESS: 'Un nouvel e-mail de confirmation vient de vous être envoyé.',
  LOGIN_RESEND_CONFIRMATION_ERROR:
    "L'e-mail de confirmation n'a pas pu être envoyé. Merci de réessayer un peu plus tard.",
  SHOW_PASSWORD: 'Afficher le mot de passe',
  HIDE_PASSWORD: 'Masquer le mot de passe',

  MODAL_OK: 'OK',
  MODAL_CANCEL: 'Annuler',
  MODAL_DUPLICATE_FILE_TITLE: 'Fichier déjà importé',
  MODAL_DUPLICATE_FILE_DESCRIPTION: 'Vous avez déjà importé un fichier portant ce nom :',

  PLUS_MATERIAL_HINT: 'Idéal pour l’immersion en seau à glace',
  LOADING_DATA_ISSUE_JOB: 'Veuillez patienter pendant que nous récupérons vos configurations de tâche...',
  SHOW_UNIT_COUNT: 'Afficher le nombre d’unités',
  LOT: 'LOT (Optionnel)',
  LINE_1: 'ligne 1',
  LINE_2: 'ligne 2',
  LINE_3: 'ligne 3',
  LINE_4: 'ligne 4',
  PROOFING_SERVICE: 'Impression Test',

  ORDER_TEMPLATES_TITLE: 'Modèles de commande',
  ORDER_TEMPLATES_SELECT: 'Modèle de commande sélectionné',
  ORDER_TEMPLATES_SELECT_PLACEHOLDER: 'Veuillez sélectionner un modèle de commande',
  ORDER_TEMPLATES_NO_TEMPLATES: "Aucun modèle de commande n'est disponible.",

  PRODUCTION_TYPE_STANDARD: 'Standard',
  PRODUCTION_TYPE_EXPRESS: 'Express en 48h',
  PRODUCTION_TYPE_SUPER_EXPRESS: 'Super Express en 24h',
  PRODUCTION_TYPE_ESTIMATED_SHIPPING_DATE: "Date d'envoi estimée",
  PRODUCTION_TYPE_SHIPPING_DATE: "Date d'envoi",
  PRODUCTION_TYPE_NOT_POSSIBLE: 'Non disponible',

  SHOW_PRICE_IN_CURRENCY: 'Afficher le prix en {currency}',
  CURRENCY_SWITCH_DISABLED_CART_NOT_EMPTY:
    'La devise ne peut pas être modifiée tant que votre panier contient des articles.',
  CART_MIXED_CURRENCY_WARNING:
    'Votre panier contient des articles dans différentes devises. Veuillez retirer les articles dans une devise différente avant de passer la commande.',
  CHECKOUT_USER_DISABLED:
    "Votre compte n'est pas autorisé à passer des commandes. Veuillez contacter notre service client.",
  DESIGN_SERVICE_CURRENCY_DISABLED: "Le Design Service ne peut être commandé qu'en {currency}.",
  PACKAGE_ORDER_CURRENCY_DISABLED: "Ce forfait ne peut être commandé qu'en {currency}.",
  CHANGE_CURRENCY_CALCULATOR: "Veuillez d'abord modifier la devise dans le calculateur de la page d'accueil.",

  CART_ITEM_DISCOUNT_NOT_APPLICABLE:
    "Aucune remise client ne sera accordée sur cet article en raison d'une tarification spéciale.",
  UPLOAD_SORTS_CONFIG_NOT_SAVED:
    "Votre configuration des variantes n'a pas pu être enregistrée. Veuillez vérifier que les quantités de toutes les variantes correspondent à la quantité totale et réessayer.",
  HPI_WHITE: 'Blanc opaque',
  YES: 'Oui',
  NO: 'Non',

  UPS_STANDARD_SHIPPING: 'UPS Standard',
  UPS_EXPRESS_SHIPPING: 'UPS Express Saver',
  UPS_STANDARD_SHIPPING_NEUTRAL: 'UPS Standard – Compensation des émissions de CO₂',
  UPS_EXPRESS_SHIPPING_NEUTRAL: 'UPS Express Saver – Compensation des émissions de CO₂'
} as const
